export default "/50f517735fec46580f19aae3e56e9fe21614ea75/5640253749f57ce229257494a6b0bc26.svg";